
export class RangeContext {
    constructor(public $implicit: number) {}
}
